module.exports = __webpack_public_path__ + "static/media/logo.5fe8b570.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Training/images/logo.png
// module id = 3231
// module chunks = 0